<div class="multi-color-progress-bar">
  <div class="title">{{ title }}</div>
  <div class="progress">
    <div
      class="fill"
      *ngIf="headCount; else other_content"
      style="width: 100%; background-color: #377dc7"
    >
      <span>{{ headCount }}</span>
    </div>
  </div>
  <div class="tooltip" *ngIf="tootip"><span class="icon">i</span>
    <div class="tooltip-content">
      <label>{{ title }}</label>
      <ul>
        <li *ngFor="let progress of data"><span>{{progress.name}} - {{ progress.value }}%</span></li>
      </ul>
    </div>
  </div>
</div>

<ng-template #other_content>
  <div
    class="fill"
    *ngFor="let progress of data; let i = index"
    [ngStyle]="{ width: progress.value + '%', backgroundColor: colors[i] }"
  >
    <span
      ><span *ngIf="progress.label">{{ progress.label }} :</span>
      {{ progress.value }}%</span
    >
  </div>
</ng-template>
